module.exports = __webpack_public_path__ + "static/media/avatar02@2x.1eefdc16.png";